import hardcodedPrices from './hardcoded-prices.json'

export interface BoxPriceDetails {
  price_per_portion: string
  price_per_portion_discounted: string
  product_total: string
  recipe_total: string
  surcharge_total: string
  recipe_total_discounted: string
  recipe_discount: string
  flat_discount_applied: boolean
  amount_off: string | null
  percentage_off: string
  promo_code: boolean
  promo_code_valid: boolean
  delivery_total: string
  gross_total: string
  vat_charged: string
  vat_rate: string
  total_excluding_vat: string
  total: string
  total_discount: string
  is_delivery_free: boolean
}

export interface BoxPrices {
  [key: string]: {
    [key: string]: {
      vegetarian?: BoxPriceDetails
      gourmet: BoxPriceDetails
    }
  }
}

export interface BoxPricesResponse {
  data: BoxPrices
  meta: never[]
}

const USE_HARDCODED_PRICES = true

export const fetchPrices = (): BoxPricesResponse => {
  // In the future, this function should fetch prices from an API
  if (USE_HARDCODED_PRICES) {
    return { meta: [], data: hardcodedPrices }
  }
  // TODO: Implement API fetching logic here
  return { meta: [], data: hardcodedPrices }
}

export interface PortionSelection {
  people: string
  recipes: string
}
export const defaultPortionSelection = { people: '4', recipes: '5' }
